import { BrowserRouter as Router } from "react-router-dom";
import { UserProvider } from "./context/useInfo";
import AppContent from "./components/survayRoutes";
import { useEffect } from "react";
import CookieYesController from "./components/cookieYesController";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CustomCookieBanner from "./components/CustomCookieBanner";

const stripePromise = loadStripe(
  "pk_live_51QA7KrJM0DnG2MaAT5AlDSYQutafMAuXjZDv8XQysswJSypH0X2cIKm7yff2A6AhEdXHMjkFuHOlklYrTS3ZR2Zp00fMWhc20Y", {
  locale: 'en', // Принудительно английский
}
);

function App() {
  useEffect(() => {
    function preventZoom(event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }

    document.addEventListener("touchstart", preventZoom, { passive: false });
    document.addEventListener("touchmove", preventZoom, { passive: false });

    return () => {
      document.removeEventListener("touchstart", preventZoom);
      document.removeEventListener("touchmove", preventZoom);
    };
  }, []);

  return (
    <UserProvider>
      <Router>
        <CookieYesController />
        <CustomCookieBanner />
        <Elements stripe={stripePromise}>
          <AppContent />
        </Elements>
      </Router>
    </UserProvider>
  );
}

export default App;
